import { useEffect, useState } from 'react';
import { Breadcrumb, Button, Col, Divider, Row, Table, message } from 'antd';
import { ReactComponent as Back } from '../../Images/Back.svg';
import { fetchVendorById } from '../../slices/vendor';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { EditOutlined } from '@ant-design/icons';

const ViewVendor = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const { user: currentUser } = useSelector(state => state.auth);
    const [vendor, setVendor] = useState(null);
    const navigate = useNavigate();
    useEffect(() => {
        const fetchVendor = async () => {
            try {
                dispatch(fetchVendorById(id))
                    .unwrap()
                    .then(response => {
                        if (response) {
                            setVendor(response.results.data[0]);
                        }
                    })
                    .catch(error => {
                        console.error('');
                    });
            } catch (error) {
                if (typeof error === 'object' && error !== null) {
                    const messages = [];
                    for (const key in error) {
                        if (Array.isArray(error[key])) {
                            messages.push(`${key}: ${error[key].join(', ')}`);
                        }
                    }

                    if (messages.length > 0) {
                        message.error(messages.join('; '));
                    } else {
                        message.error('An unknown error occurred.');
                    }
                } else if (typeof error === 'string') {
                    message.error(error);
                } else if (error instanceof Error) {
                    message.error(error.message);
                } else {
                    message.error('An unknown error occurred.');
                }
            }
        };

        fetchVendor();
    }, [id]);

    const columns = [
        {
            title: 'Sr. No.',
            dataIndex: 'SrNo',
            key: 'SrNo',
            render: (text, record, index) => index + 1,
            sorter: true,
        },
        {
            title: 'Person Name',
            dataIndex: 'person_name',
            key: 'person_name',
        },
        {
            title: 'Designation',
            dataIndex: 'designation',
            key: 'designation'
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email'
        },
        {
            title: 'Mobile',
            dataIndex: 'contact_number',
            key: 'contact_number'
        }
    ];

    const columnsBanking = [
        {
            title: 'Sr. No.',
            dataIndex: 'SrNo',
            key: 'SrNo',
            render: (text, record, index) => index + 1,
            sorter: true,
        },
        {
            title: 'Bank Name',
            dataIndex: 'bank_name',
            key: 'bank_name',
        },
        {
            title: 'Bank Account Number',
            dataIndex: 'bank_account_number',
            key: 'bank_account_number'
        },
        {
            title: 'Bank IFSC Code',
            dataIndex: 'bank_ifsc_code',
            key: 'bank_ifsc_code'
        },
        {
            title: 'Branch Address',
            dataIndex: 'branch_address',
            key: 'branch_address'
        },
        {
            title: 'BENEFICIARY SWIFT CODE',
            dataIndex: 'beneficiary_swift_code',
            key: 'beneficiary_swift_code'
        },
        {
            title: 'Bank AD Code',
            dataIndex: 'bank_ad_code',
            key: 'bank_ad_code'
        }
    ];

    return (
        <div>
            <div className='sticyaction'>
                <Row className="pagenamerow mb-0" justify="space-between" align="middle">
                    <Col>
                        <h2 style={{ margin: 0 }}>View Vendor</h2>
                        <div className="bredcrumbwrp">
                            <Link to="/vendor-list" className="back">
                                <Back /> BACK
                            </Link>
                            <Breadcrumb
                                items={[
                                    { title: <Link to="/dashboard">Home</Link> },
                                    { title: <Link to="/vendor-list">Vendors</Link> },
                                    { title: 'View Vendor' },
                                ]}
                            />
                        </div>
                    </Col>
                    <div>
                        {currentUser.permissions.permissions.vendor.includes("change_vendor") && (
                            <Button
                                type="primary"
                                style={{
                                    marginBottom: '20px',

                                    marginRight: '10px',
                                }}
                                icon={<EditOutlined />}
                                onClick={() => navigate(`/edit-vendor/${vendor?.id}`)}
                            >
                                Edit Vendor
                            </Button>
                        )}
                    </div>
                </Row>

            </div>
            <div className='px-4'
                style={{ position: 'sticky', top: 0, zIndex: 1000, background: '#fff' }}
            >
                <Row gutter={[16, 16]} className="viewform">
                    <Col xs={24} sm={12} lg={8} xl={6}>
                        <label className="customlabel">Legal Name of Business</label>
                        <div className="customvalue">{vendor?.person_name}</div>
                    </Col>

                    {vendor?.business_type === "INDIAN" && (
                        <>
                            <Col xs={24} sm={12} lg={8} xl={6}>
                                <label className="customlabel">GST Number
                                </label>
                                <div className="customvalue">
                                    {vendor?.gst_no ? vendor.gst_no : 'N/A'}
                                </div>
                            </Col>
                            <Col xs={24} sm={12} lg={8} xl={6}>
                                <label className="customlabel">Aadhar No
                                </label>
                                <div className="customvalue">
                                    {vendor?.udyam_aadhaar_no ? vendor.udyam_aadhaar_no : "N/A"}

                                </div>
                            </Col>
                        </>
                    )}
                    {vendor?.business_type === "OVERSEAS" && (
                        <>
                            <Col xs={24} sm={12} lg={8} xl={6}>
                                <label className="customlabel">Import Export Code
                                </label>
                                <div className="customvalue">
                                    {vendor?.import_export_code ? vendor.import_export_code : "N/A"}
                                </div>
                            </Col>
                            <Col xs={24} sm={12} lg={8} xl={6}>
                                <label className="customlabel">Baneficery Agent Code
                                </label>
                                <div className="customvalue">
                                    {vendor?.beneficiary_agent_code ? vendor.beneficiary_agent_code : "N/A"}
                                </div>
                            </Col>
                        </>
                    )}
                    <Col xs={24} sm={12} lg={8} xl={6}>
                        <label className="customlabel">Vendor Trade Name
                        </label>
                        <div className="customvalue">
                            {vendor?.vendor_trade_name || 'N/A'}
                        </div>
                    </Col>
                    <Col xs={24} sm={12} lg={8} xl={6}>
                        <label className="customlabel">Vendor Code
                        </label>
                        <div className="customvalue">
                            {vendor?.vendor_code_as_per_company_erp || 'N/A'
                            }
                        </div>
                    </Col>
                    <Col xs={24} sm={12} lg={8} xl={6}>
                        <label className="customlabel">Fax Number</label>
                        <div className="customvalue">{vendor?.fax_number || 'N/A'}</div>
                    </Col>
                    <Col xs={24} sm={12} lg={8} xl={6}>
                        <label className="customlabel">Website
                        </label>
                        <div className="customvalue">{vendor?.website || 'N/A'}</div>
                    </Col>
                    <Col xs={24} sm={12} lg={8} xl={6}>
                        <label className="customlabel">Designation
                        </label>
                        <div className="customvalue">
                            {vendor?.designation || 'N/A'}
                        </div>
                    </Col>
                    <Col xs={24} sm={12} lg={8} xl={6}>
                        <label className="customlabel">
                            Contact Number
                        </label>
                        <div className="customvalue">
                            +{vendor?.phone || 'N/A'}
                        </div>
                    </Col>
                    <Col xs={24} sm={12} lg={8} xl={6}>
                        <label className="customlabel">
                            Email
                        </label>
                        <div className="customvalue">
                            {vendor?.email || 'N/A'}
                        </div>
                    </Col>
                </Row>
                <Divider />
                <Row gutter={[16, 16]} className="viewform">
                    <Col xs={24} sm={12} lg={8} xl={6}>
                        <label className="customlabel">Registered Business Address</label>
                        <div className="customvalue">
                            {`${vendor?.registered_business_address_building || ""} 
        ${vendor?.registered_business_address_area || ""} 
        ${vendor?.registered_business_address_landmark || ""} 
        ${vendor?.registered_business_address_city || ""} 
        ${vendor?.registered_business_address_state || ""} 
        ${vendor?.registered_business_address_country || ""} 
        - ${vendor?.registered_business_address_pincode || ""}`
                                .trim()
                                .toUpperCase()}
                        </div>
                    </Col>
                    <Col xs={24} sm={12} lg={8} xl={6}>
                        <label className="customlabel">Trading Address</label>
                        <div className="customvalue">
                            {`${vendor?.trading_address_building || ""} 
        ${vendor?.trading_address_area || ""} 
        ${vendor?.trading_address_landmark || ""} 
        ${vendor?.trading_address_city || ""} 
        ${vendor?.trading_address_state || ""} 
        ${vendor?.trading_address_country || ""} 
        - ${vendor?.trading_address_pincode || ""}`
                                .trim()
                                .toUpperCase()}
                        </div>
                    </Col>
                </Row>
                <Divider />
                <div className="flex justify-between gridtitle">
                    <h3>Contact Persons</h3>
                </div>
                <Table className='px-0'
                    dataSource={vendor?.keypersons}
                    columns={columns}
                />
                <Divider />
                <div className="flex justify-between gridtitle">
                    <h3>Bank Details</h3>
                </div>

                <Table className='px-0'
                    dataSource={vendor?.bankdetails}
                    columns={columnsBanking}
                />

            </div>

        </div>
    );
};

export default ViewVendor;
